import React, { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { PermissionsProvider } from './utils/permissions/PermissionsContext';
import setupInterceptors from "./utils/setupInterceptors";
import tokenExpirationChecker from "./utils/tokenExpirationChecker";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { createBrowserHistory } from "history";
import Cookies from "js-cookie";
import { logoutUser, setCurrentUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import Events from "./components/events/Events";
import RawEvents from "./components/events-raw/RawEvents";
import Users from "./components/users/Users";
import FiredUsers from "./components/users/fired-users/FiredUsers";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Home from "./components/home/Home";
import Devices from "./components/devices/Devices";
import Company from "./components/company/Company";
import NotFound from "./components/notfound/NotFound";
import OfflineCards from "./components/devices/offline-cards-management/OfflineCards";
import PasswordReset from "./components/profile/PasswordReset";
import Admin from "./components/admin/Admin";
import Support from "./components/support/Support";
import Box from "@material-ui/core/Box";
import IssuedCards from "./components/devices/offline-cards-management/IssuedCards";
import Rooms from "./components/rooms/Rooms";
import Doors from "./components/doors/Doors";
import Invite from "./components/invite/Invite";
import SportsTickets from "./components/sports-tickets/SportsTickets";
import Allocation from "./components/devices/fingers-management/FingersManagement";
import FloorManagement from "./components/devices/floors-management/FloorManagement";
import GroupManagement from "./components/devices/groups-management/GroupManagement";
import DeviceSetup from "./components/devices/device-setup/DeviceSetup";
import Fitness from "./components/fitness/Fitness";
import FitnessReport from "./components/fitness/FitnessReport";

// Setup axios interceptors for automatic session expiration handling
setupInterceptors();

// Check for token to keep user logged in
if (Cookies.get("Biodit")) {
    // Set auth token to header
    const token = Cookies.get("Biodit");
    setAuthToken(token);
    // Decode token and get user info and exp
    const decoded = jwt_decode(token);
    // Set user and isAuthenticated
    store.dispatch(setCurrentUser(decoded));
    // Check for expired token
    const currentTime = Date.now() / 1000; // to get in milliseconds
    if (decoded.exp < currentTime) {
        // Logout user
        store.dispatch(logoutUser());

        // Redirect to login
        window.location.href = "./login";
    }
}

const history = createBrowserHistory();

class App extends Component {
    componentDidMount() {
        // Start periodic token expiration checking if user is logged in
        if (Cookies.get("Biodit")) {
            tokenExpirationChecker.start();
        }
    }

    componentWillUnmount() {
        // Stop token expiration checking when component unmounts
        tokenExpirationChecker.stop();
    }

    render() {
        return (
            <React.Fragment>
                <Box>
                    <Provider store={store}>
                        <PermissionsProvider>
                        <Router history={history}>
                            <div>
                                <Route exact path="/" component={Login} />
                                <Route exact path="/register" component={Register} />
                                <Route exact path="/login" component={Login} />
                                <Route exact path="/404" component={NotFound} />
                                <Switch>
                                    <PrivateRoute exact path="/version" component={Home} />
                                    <PrivateRoute exact path="/events" component={Events} />
                                    <PrivateRoute
                                        exact
                                        path="/raw-events"
                                        component={RawEvents}
                                    />
                                    <PrivateRoute exact path="/users" component={Users} />
                                    <PrivateRoute exact path="/invite" component={Invite} />
                                    <PrivateRoute
                                        exact
                                        path="/sports-tickets"
                                        component={SportsTickets}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/dismissed-users"
                                        component={FiredUsers}
                                    />
                                    <PrivateRoute exact path="/company" component={Company} />
                                    <PrivateRoute exact path="/devices" component={Devices} />
                                    <PrivateRoute
                                        exact
                                        path="/device-setup"
                                        component={DeviceSetup}
                                    />
                                    <PrivateRoute path="/floors" component={FloorManagement} />
                                    <PrivateRoute path="/groups" component={GroupManagement} />
                                    <PrivateRoute
                                        exact
                                        path="/allocation"
                                        component={Allocation}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/cards/offline"
                                        component={OfflineCards}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/cards/issued"
                                        component={IssuedCards}
                                    />
                                    <PrivateRoute exact path="/rooms" component={Rooms} />
                                    <PrivateRoute exact path="/doors" component={Doors} />
                                    <PrivateRoute
                                        exact
                                        path="/password-reset"
                                        component={PasswordReset}
                                    />
                                    <PrivateRoute exact path="/support" component={Support} />
                                    <PrivateRoute
                                        exact
                                        path="/admin-settings"
                                        component={Admin}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/fitness"
                                        component={Fitness}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/fitness-report"
                                        component={FitnessReport}
                                    />
                                </Switch>
                            </div>
                        </Router>
                        </PermissionsProvider>
                    </Provider>
                </Box>
            </React.Fragment>
        );
    }
}
export default App;
